// extracted by mini-css-extract-plugin
export var option = "newsletter-question-module--option--fc128";
export var options = "newsletter-question-module--options--dc101";
export var spin = "newsletter-question-module--spin--cd4dd";
export var wrapper = "newsletter-question-module--wrapper--85fa4";